import {AlertController, ToastController} from '@ionic/angular';
import { Injectable } from '@angular/core';
import {Constants} from '../models/contants.models';
import {TranslateService} from '@ngx-translate/core';
import {isNumeric} from "rxjs/internal-compatibility";

@Injectable()
export class Functions {
    defaultLanguageCode = 'en';
    constructor(public alertCtrl: AlertController,
                public toastCtrl: ToastController, private translate: TranslateService) {
        const defaultLang = window.localStorage.getItem(Constants.KEY_DEFAULT_LANGUAGE);
        if (defaultLang) { this.defaultLanguageCode = defaultLang; }
    }

    public validPhone(pn: string){
        const phoneStart = ['33', '44', '55', '66', '77', '31'];
        if (pn.length === 8 && isNumeric(pn)){
                    return true;
        }
        if ((pn.length === 12 && pn.startsWith('+974'))&& isNumeric(pn) ){
                    return true;
        }
        if ((pn.length === 13 && pn.startsWith('00974')) && isNumeric(pn) ) {
                    return true;
        }
        return false;
    }
    public fullPhone(pn: string){
        const phoneStart = ['33', '44', '55', '66', '77', '31'];
        if (pn.length === 8){
                    return '+974' + pn;
        }
        if ((pn.length === 12 && pn.startsWith('+974')) ){
            pn = pn.slice(4);
                    return '+974' + pn;
        }
        if ((pn.length === 13 && pn.startsWith('00974')) ) {
            pn = pn.slice(5);
                    return '+974' + pn;
        }
        return null;
    }
    public async showAlert(title, msg) {
        const alert = await this.alertCtrl.create({
            header: title,
            subHeader: msg,
            buttons: ['OK']
        });
        await alert.present();
    }
    public async alertConfirm(header, message) {
        let result = false;
        const alert = await this.alertCtrl.create({
            header,
            message,
            buttons: [
                {
                    text: 'Cancel',
                    handler: () => {
                        console.log('Confirm Cancel');
                        result = false;
                    }
                }, {
                    text: 'Ok',
                    handler: () => {
                        console.log('Confirm Okay');
                        result = true;
                    }
                }
            ]
        });

        await alert.present();
        return result;
    }
    translateNow(val){
        this.translate.get(val).subscribe(
            value => {
                val = value;
            });
        return val;
    }
    async showToast(msg) {
        const toast = await this.toastCtrl.create({
            message: msg,
            duration: 3000
        });
        await toast.present();
    }
    validEmail(email: string) {
        const format = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-]*$/;
        if (email.match(format)){
            return true;
        }
        return false;
    }
}
